<template>
	<div class="eia-faq">
		<header>
			<eia-heading level="h1">FAQs</eia-heading>
		</header>

		<eia-input
			type="search"
			v-model="searchTerm"
			placeholder="Search for help articles...">
		</eia-input>

		<eia-faq-item-summary
			v-for="item in faqSearchResults"
			:key="item.title"
			:item="item">
		</eia-faq-item-summary>

		<p v-if="hasNoResults"
			class="eia-faq__no-search-results">
			No results found.
		</p>
	</div>
</template>

<script>
import faqs from '@/copy/faq.js';

export default {
	name: 'eia-faq',

	data() {
		return {
			faqs,
			searchTerm: '',
		};
	},

	computed: {
		faqSearchResults() {
			if( !this.searchTerm ) {
				return faqs;
			}

			return faqs.filter( d => {
				const title = d.title.toLowerCase(),
					body = ( d.searchBody || d.body.toLowerCase() );

				return title.includes( this.searchTerm ) || body.includes( this.searchTerm );
			} );
		},

		hasNoResults() {
			return this.faqSearchResults.length === 0;
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-heading {
	margin-top: 32px;
}

.eia-input {
	width: 100%;
	max-width: 400px;
	margin: 32px 0;
}

.eia-faq__no-search-results {
	margin: 24px;
	color: $color-danger;
	text-align: center;
}
</style>
